module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/RIB-fbc71420847d62df4705fe07c3387585.svg";